import { z } from 'zod';
import { jArticleLittleSchema, jArticleListSchema } from './article';
import { jFileLittleSchema } from './file';
import { audienceAutocompleteSchema } from './autocomplete';
import { formatListSchema } from './utils';

export const mediaLibraryFolderSchema = jArticleLittleSchema.extend({
    attachment: jFileLittleSchema,
    description: z.string(),
});
export type MediaLibraryLittle = z.infer<typeof mediaLibraryFolderSchema>;

export const mediaLibraryListSchema = jArticleListSchema.extend({
    description: z.string(),
    attachment: jFileLittleSchema,
    _audience: audienceAutocompleteSchema.array(),
});
export type MediaLibraryList = z.infer<typeof mediaLibraryListSchema>;

export const getUnclassifiedFilesParamsSchema = z.object({
    format: formatListSchema,
    page: z.number().optional(),
    limit: z.number().optional(),
    nolimit: z.boolean().optional(),
});
export type GetUnclassifiedFilesParams = z.infer<typeof getUnclassifiedFilesParamsSchema>;

export const mediaLibraryFilesStatsSchema = z.object({
    id: z.number(),
    idFolder: z.number().optional(),
    fileName: z.string(),
    nbViews: z.number(),
    nbDistinctViews: z.number(),
    nbDownloads: z.number(),
});
export type MediaLibraryFilesStats = z.infer<typeof mediaLibraryFilesStatsSchema>;

export const mediaLibraryFolderStatsSchema = z.object({
    id: z.number(),
    folderName: z.string(),
    nb: z.number(),
    nbDistinct: z.number(),
});
export type MediaLibraryFolderStats = z.infer<typeof mediaLibraryFolderStatsSchema>;

export const mediaLibraryStatsSchema = z.object({
    nbFolders: z.number(),
    nbFiles: z.number(),
});
export type MediaLibraryStats = z.infer<typeof mediaLibraryStatsSchema>;

export const moveMediaLibraryFileParamsSchema = z.object({
    uriFile: z.string(),
    uriFolder: z.string(),
    publishTo: z.string().array(),
});
export type MoveMediaLibraryFileParams = z.infer<typeof moveMediaLibraryFileParamsSchema>;
